import { hasPermission } from "leatherman-js/utils/auth";
import store from "@/store";

const canDelete = (resource) => hasPermission(store.getters["auth/getUser"], "delete", resource);
const canRead = (resource) => hasPermission(store.getters["auth/getUser"], "read", resource);
const canWrite = (resource) => hasPermission(store.getters["auth/getUser"], "write", resource);

export { canDelete, canRead, canWrite };
